import {
  createTestListPagination,
  createTestCasesParamsSelector,
  createTestCasesTrendsParamsSelector,
  createTestListSelector,
  createStatusSelector,
} from '../../../common/test-list/selectors';
import { getFiltersParams, getFiltersAsQueryObject } from '../../../vdc/filters/selectors';
import { STORAGE_TESTS_KEY } from '../../../../constants';
import { TRACKING_SUB_AREA } from '../../../../trackingV2';

const testListStore = (store) => store.apps.analytics.vdc.testHistory.testList;
export const routerLocation = (store) => store.router.location;

export const testListPagination = createTestListPagination(testListStore);
export const testCasesParamsSelector = createTestCasesParamsSelector(
  getFiltersParams,
  testListStore,
);
export const testCasesTrendsParamsSelector = createTestCasesTrendsParamsSelector(
  testCasesParamsSelector,
  testListStore,
);
export const testListSelector = createTestListSelector({
  testListStore,
  testListPagination,
  getFiltersAsQueryObject,
  type: 'vdc',
  productSubArea: TRACKING_SUB_AREA.TEST_HISTORY,
});
export const statusSelector = createStatusSelector(STORAGE_TESTS_KEY);
